import { CapsuleTabs, Image, Grid, Toast } from 'antd-mobile'
import React, { useCallback, useEffect, useState } from 'react'
import './index.css'
import { teamApi } from '../../features/team/api/teamApi'

export default function ActiveCharts({ gameYearId }) {

    const [chartsInfo, setChartsInfo] = useState()

    const getUserList = useCallback(() => {
        Toast.show({
            icon: 'loading',
            duration: 0
        })
        teamApi.getCharts(gameYearId)
            .then(function (response) {
                setChartsInfo(response.data.data)
            })
            .catch(function () {
                Toast.show({
                    icon: 'fail',
                    content: '获取详情失败'
                })
            })
            .finally(() => {
                Toast.clear()
            });
    }, [gameYearId])

    useEffect(() => {
        getUserList()
    }, [getUserList])

    const rankFunc = (rank) => {
        if (rank === "1") {
            return (
                <div className="rank-top-3">
                    <Image
                        src={"https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no1.png?x-oss-process=image/resize,m_fixed,limit_0,h_60,w_60"}
                        width={26}
                        height={26}
                    />
                </div>
            )
        } else if (rank === "2") {
            return (
                <div className="rank-top-3">
                    <Image
                        src={"https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no2.png?x-oss-process=image/resize,m_fixed,limit_0,h_60,w_60"}
                        width={26}
                        height={26}
                    /></div>)
        } else if (rank === "3") {
            return (
                <div className="rank-top-3">
                    <Image
                        src={"https://huaxi-kepeng.oss-cn-chengdu.aliyuncs.com/no3.png?x-oss-process=image/resize,m_fixed,limit_0,h_60,w_60"}
                        width={26}
                        height={26}
                    /></div>)
        } else {
            return (
                <div className="rank-number-box">{rank}</div>
            )
        }
    }

    const dataInfo = () => {
        const data = chartsInfo?.shootList ?? []
        return (
            <div className="rank-list-wrapper">
                <div className="rank-list-header">
                    <Grid columns={24}>
                        <Grid.Item span={10}>球员</Grid.Item>
                        <Grid.Item span={5} style={{ textAlign: "center" }}>进球</Grid.Item>
                        <Grid.Item span={5} style={{ textAlign: "center" }}>场均</Grid.Item>
                        <Grid.Item span={4} style={{ textAlign: "center" }}>胜平负</Grid.Item>
                    </Grid>
                </div>
                <div style={{ padding: '0 12px' }}>
                    {data.map((item, index) => (
                        <div key={index} className="rank-item-container">
                            <Grid columns={24}>
                                <Grid.Item span={3} style={{ display: 'flex', alignItems: 'center' }} >
                                    {rankFunc(item.rank)}
                                </Grid.Item>
                                <Grid.Item span={3} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Image
                                        src={item.image + "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90"}
                                        className="player-avatar-rank"
                                        style={{ borderRadius: 12 }}
                                        fit='cover'
                                        width={32}
                                        height={32}
                                    />
                                </Grid.Item>
                                <Grid.Item span={4} className="player-name-rank" style={{ display: 'flex', alignItems: 'center' }} >
                                    {item.name}
                                </Grid.Item>
                                <Grid.Item span={5} style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                    <span className="score-value-rank">{item.score}</span>
                                    {item.penaltyGoals !== "0" && <span className="score-penalty-info">({item.penaltyGoals})</span>}
                                </Grid.Item>
                                <Grid.Item span={5} className="avg-score-rank" style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                    {item.avgScore}
                                </Grid.Item>
                                <Grid.Item span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: "center", flexDirection: 'column' }}>
                                    <div className="record-pill-container">
                                        <span className="record-win">{item.successCount}</span>
                                        <span style={{ margin: '0 2px', opacity: 0.3 }}>/</span>
                                        <span className="record-draw">{item.drawCount}</span>
                                        <span style={{ margin: '0 2px', opacity: 0.3 }}>/</span>
                                        <span className="record-loss">{item.failCount}</span>
                                    </div>
                                    <div className="total-count-rank">共{item.totalCount}场</div>
                                </Grid.Item>
                            </Grid>
                            {index !== data.length - 1 && <div className="rank-item-divider" />}
                        </div>
                    ))}
                </div>
            </div>
        )
    }


    const dataInfo2 = () => {
        const data = chartsInfo?.assistList ?? []
        return (
            <div className="rank-list-wrapper">
                <div className="rank-list-header">
                    <Grid columns={24}>
                        <Grid.Item span={10}>球员</Grid.Item>
                        <Grid.Item span={5} style={{ textAlign: "center" }}>助攻</Grid.Item>
                        <Grid.Item span={5} style={{ textAlign: "center" }}>场均</Grid.Item>
                        <Grid.Item span={4} style={{ textAlign: "center" }}>胜平负</Grid.Item>
                    </Grid>
                </div>
                <div style={{ padding: '0 12px' }}>
                    {data.map((item, index) => (
                        <div key={index} className="rank-item-container">
                            <Grid columns={24}>
                                <Grid.Item span={3} style={{ display: 'flex', alignItems: 'center' }} >
                                    {rankFunc(item.rank)}
                                </Grid.Item>
                                <Grid.Item span={3} style={{ display: 'flex', alignItems: 'center' }}>
                                    <Image
                                        src={item.image + "?x-oss-process=image/resize,m_fill,w_100,h_100,limit_0/auto-orient,1/quality,q_90"}
                                        className="player-avatar-rank"
                                        style={{ borderRadius: 12 }}
                                        fit='cover'
                                        width={32}
                                        height={32}
                                    />
                                </Grid.Item>
                                <Grid.Item span={4} className="player-name-rank" style={{ display: 'flex', alignItems: 'center' }} >
                                    {item.name}
                                </Grid.Item>
                                <Grid.Item span={5} style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                    <span className="score-value-rank" style={{ color: '#00B42A' }}>{item.score}</span>
                                </Grid.Item>
                                <Grid.Item span={5} className="avg-score-rank" style={{ display: 'flex', alignItems: 'center', justifyContent: "center" }}>
                                    {item.avgScore}
                                </Grid.Item>
                                <Grid.Item span={4} style={{ display: 'flex', alignItems: 'center', justifyContent: "center", flexDirection: 'column' }}>
                                    <div className="record-pill-container">
                                        <span className="record-win">{item.successCount}</span>
                                        <span style={{ margin: '0 2px', opacity: 0.3 }}>/</span>
                                        <span className="record-draw">{item.drawCount}</span>
                                        <span style={{ margin: '0 2px', opacity: 0.3 }}>/</span>
                                        <span className="record-loss">{item.failCount}</span>
                                    </div>
                                    <div className="total-count-rank">共{item.totalCount}场</div>
                                </Grid.Item>
                            </Grid>
                            {index !== data.length - 1 && <div className="rank-item-divider" />}
                        </div>
                    ))}
                </div>
            </div>
        )
    }

    return (
        <div style={{ background: '#F8F9FA', minHeight: '100vh', padding: '1px 0 20px' }}>
            <CapsuleTabs style={{ '--adm-color-background': 'transparent' }}>
                <CapsuleTabs.Tab title='射手榜' key='0'>
                    {dataInfo()}
                </CapsuleTabs.Tab>
                <CapsuleTabs.Tab title='助攻榜' key='1'>
                    {dataInfo2()}
                </CapsuleTabs.Tab>
            </CapsuleTabs>
        </div>
    )
}
